import React from "react";
import { ReviewForm, ReviewFormProps } from "@comparaonline/ui-forms-review";
import { useFormatMessage } from "@comparaonline/react-intl-hooks";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import { FORM_STEP } from "../constants/testIds";
import { RATING_FIELD, USERNAME_FIELD, EMAIL_FIELD, COMMENT_FIELD } from "../constants/fieldNames";

export interface FormProps {
  onSubmit: ReviewFormProps["handleSubmit"];
  onCancel: ReviewFormProps["actionProps"]["onSecondaryClick"];
  businessUnitName: string;
}

export const Form: React.FC<FormProps> = ({ onSubmit, onCancel, businessUnitName }) => {
  const formatMessage = useFormatMessage();
  return (
    <Grid container={true} direction="column" spacing={16} data-testid={FORM_STEP}>
      <Grid item={true}>
        <Typography variant="body1" component="h3">
          {formatMessage("reviews.reviewForm.title")}
        </Typography>
      </Grid>
      <Grid item={true}>
        <ReviewForm
          fieldTexts={{
            rating: {
              name: RATING_FIELD,
              label: formatMessage("reviews.reviewForm.rateField", {
                businessName: businessUnitName
              })
            },
            username: {
              name: USERNAME_FIELD,
              label: formatMessage("reviews.reviewForm.nameField")
            },
            email: {
              name: EMAIL_FIELD,
              label: formatMessage("reviews.reviewForm.emailField")
            },
            comment: {
              name: COMMENT_FIELD,
              label: formatMessage("reviews.reviewForm.commentField")
            }
          }}
          actionProps={{
            submitText: formatMessage("reviews.reviewForm.publish"),
            secondaryText: formatMessage("reviews.reviewForm.cancel"),
            onSecondaryClick: onCancel
          }}
          handleSubmit={onSubmit}
        />
      </Grid>
    </Grid>
  );
};
